<template>
  <v-card class="ts-ranking-card" v-bind="$attrs" @click.prevent.stop="$emit('click',rankingRecord)">
    <v-card-title class="ts-ranking-card__title">
      <v-btn icon @click.stop="copyBody">
        <v-icon>mdi-content-copy</v-icon>
      </v-btn>
      <slot name="title">
        <span>{{title}}({{rankingRecordTotal}}/{{filteredRecord.length}})</span>
      </slot>
    </v-card-title>
    <v-card-text ref="body" class="ts-ranking-card__body">
      <v-list>
        <v-list-item-group>
          <v-list-item
              class="ts-ranking-card-list-item"
              v-for="(record,i) in rankingRecord" :key="i"
              v-show="record.total >= minTotal"
              :ripple="false"
              :class="{'ts-ranking-card-list-item--highlighted': isSameTeam(highlightTeam, record.players)}"
          >
            <span>{{i+1}}위</span>
            <span class="ts-ranking-card-list-item__player-wrap">
              <ts-player
                  v-for="(player,j) in record.players" :key="j"
                  :player="player"
              />
            </span>
            <span>{{record.winRatio}}%</span>
            <span>{{record.total}}전</span>
            <span>{{record.win}}승</span>
            <span>{{record.lose}}패</span>
            <br v-show="false">
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
  import TsPlayer from "./TsPlayer";
  import { copyTextToClipboard } from "../util/htmlHandler";
  import recordUtil from "@/util/recordUtil";

  export default {
    name: "TsRankingCard",
    components: {TsPlayer},
    mixins: [recordUtil],
    props: {
      highlightTeam: Array,
      relativeTeam: Array, // 상대전적일때만
      players: Array,
      records: Array,
      title: String,
      recordFilter: {
        type: Function,
        default: record => record.boksik
      },
      team: Boolean,
      minTotal: {
        type: Number,
        default: -1
      }
    },
    data () {
      return {
        comparator: (a, b) => {
          return b.winRatio - a.winRatio ||
            b.total - a.total ||
            b.win - a.win ||
            a.lose - b.lose
        }
      }
    },
    computed: {
      teamMaker (){
        if(!this.team)
          return (players) => players.map((p) => ({
            players: [p],
            win: 0,
            lose: 0
          }))
        else
          return (players) => {
            const boksikTeam = []
            players.forEach((p1,i) =>
              boksikTeam.push(...players
                .filter((p2,j) => p2.name !== p1.name && j > i)
                .map(p2 => ({players: [p1, p2].sort((a,b) => `${a.name}`.localeCompare(`${b.name}`)), win: 0, lose: 0}))
              )
            )
            return boksikTeam
          }
      },
      filteredRecord () {
        return this.records.filter(this.recordFilter).sort((a,b) => `${a.date}`.localeCompare(`${b.date}`))
      },
      rankingRecord () {
        if (!(this.players && this.players.length) || !this.records) return

        const teamRecord = this.teamMaker(this.players).filter((team) => {
          return !this.relativeTeam || !this.isSameTeam(team.players, this.relativeTeam)
        })

        this.filteredRecord.forEach((record) => {
          const totalPlayers = record.players || []
          const winners = record.winners || []
          const losers = record.losers || []
          teamRecord.forEach(team => {
            const teamPlayers = team.players
            let winDelta = 0
            let loseDelta = 0
            if (teamPlayers.length === teamPlayers.filter(p => winners.includes(p.name)).length){ winDelta++;team[this.relativeTeam ? 'lose' : 'win']++ }
            else if (teamPlayers.length === teamPlayers.filter(p => losers.includes(p.name)).length){ loseDelta++;team[this.relativeTeam ? 'win' : 'lose']++}
            // 날짜별 레코딩을 위함
            if (teamPlayers.length === teamPlayers.filter(p => totalPlayers.includes(p.name)).length){
              if(!team.history) team.history = []
              team.history.push({
                date: record.date,
                win: team.win,
                lose: team.lose,
                winDelta,
                loseDelta,
                ...this.calculatedResultMapper(team)
              })
            }
          })
        })

        const calculatedRecordEachTeam = Object.values(teamRecord)
        calculatedRecordEachTeam.forEach(item => {
          Object.assign(item, this.calculatedResultMapper(item))
        })
        calculatedRecordEachTeam.sort(this.comparator)
        this.$emit('calculated',calculatedRecordEachTeam)
        return calculatedRecordEachTeam
      },
      rankingRecordTotal () {
        let sum = 0
        this.rankingRecord && this.rankingRecord.forEach(({total}) => (sum += total))
        return sum / 2
      }
    },
    methods: {
      calculatedResultMapper({win = 0, lose = 0}) {
        const total = win - -lose
        return {
          total,
          winRatio: Math.round(win * 1000 / (total || 1)) / 10
        }
      },
      copyBody () {
        const data = this.$refs.body.innerHTML
          .replace(/<br[^>]*>/g, '\n')
          .replace(/<[^<>]*>/gi, ' ')
          .replace(/(^\s*|\s*$)/g, '')
          .replace(/ +/gi, ' ')
          .replace(/\n\s+/gi, '\n')
        copyTextToClipboard(data, this.$el)
        this.$alert('Content is copied to clipboard')
      },
    }
  }
</script>

<style lang="scss">
  .ts-ranking-card-list-item {
    padding:0 !important;
    user-select: initial;
    cursor: initial;
    display: flex;
    justify-content: space-between;
    & > span{
      display:flex;
      justify-content: center;
      flex-grow:1;
      flex-basis:0;
    }
    &--highlighted{
      background-color: #6d6d6d;
      color: white !important;
      font-weight: bold;
      &.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled){
        color: white !important;
      }
    }
    &__player-wrap{
      flex-grow:0 !important;
      flex-basis: 110px !important;
    }
  }

  .ts-ranking-card {
    height: 100%;

    &__title {
      height: 64px;
    }

    &__body {
      height: calc(100% - 64px);
      overflow: auto;
    }

    &__error-wrapper {
      max-height: 500px;
      width: 500px;
      background-color: white;
      overflow: auto;
    }
  }

</style>